import { useStyles } from '@archipro-design/aria';
import { DesignBoardDrawerHeader } from './DesignBoardRIghtSideDrawerHeader';
import { DesignBoardDrawerFooter } from './DesignBoardRightSideDrawerFooter';
import { useDesignBoardPageState } from '../context/DesignBoardContext';
import DesignBoardDrawerSelectPinsBody from './DesignBoardDrawerSelectPinsBody';
import * as S from './RightSideNewBoarderDrawer.style';
import { useFetcher } from '@remix-run/react';
import type { CopyDesignBoardPinsMutation } from 'generated/graphql';
import {
    copyToBoardClicked,
    copyToMoodBoardClicked,
} from './DesignBoardFetchers';
import { useToaster } from '~/modules/root/context/ToasterContext';
import type { OnSucessProps } from '../../hook/use-pin-move-copy-on-sucess-toast';
import { useOnSuccessToast } from '../../hook/use-pin-move-copy-on-sucess-toast';
import { useMemoizedFn } from 'ahooks';

const DesignBoardDrawerCopyPinsMain = () => {
    const { dispatch, state } = useDesignBoardPageState();
    const { css } = useStyles();
    const { toast } = useToaster();
    const { onSuccessToast } = useOnSuccessToast();

    const onClose = () => {
        dispatch({
            type: 'CloseDrawer',
        });
    };

    const onError = (errorMessage: string) => {
        toast(errorMessage, { type: 'error' });
    };

    const onSuccess = useMemoizedFn((props: OnSucessProps) => {
        onSuccessToast(props);
        onClose();
    });

    const copyPinFetcher = useFetcher<CopyDesignBoardPinsMutation>();

    if (!state.pinMoveData) return null;

    // Use buildHubId from pinMoveData to determine MoodBoard context
    // This is more reliable than useBuildHubData() which depends on route loader
    const buildHubId = state.pinMoveData.buildHubId;
    const submitToMoodBoard = !!state.pinMoveData.buildHubUrl && !!buildHubId;

    const onClickCreateButton = () => {
        if (submitToMoodBoard && buildHubId) {
            // MoodBoard context - dispatch OpenCreateMoodBoardDrawer with CopyPins action
            dispatch({
                type: 'OpenCreateMoodBoardDrawer',
                createMoodBoardInput: {
                    buildHubId,
                },
                pinActionType: 'CopyPins',
            });
        } else {
            // Design Board context
            dispatch({
                type: 'CopyDesignBoardPinsCreateNewDrawer',
            });
        }
    };

    return (
        <div className={css(S.FormClass)}>
            <DesignBoardDrawerHeader
                {...{ onClose }}
                headerTitle={'Choose location'}
            />
            <DesignBoardDrawerSelectPinsBody
                pinData={state.pinMoveData}
                onSuccess={onSuccess}
                onError={onError}
                actionTaken={'copied'}
                pinFetcher={copyPinFetcher}
                pinFetcherFunction={
                    submitToMoodBoard
                        ? copyToMoodBoardClicked
                        : copyToBoardClicked
                }
                inputLabel={'Copy to existing board'}
                listButtonLabel={'COPY'}
            />

            <DesignBoardDrawerFooter
                buttonPrimaryAction={onClickCreateButton}
                submitButtonLabel={'CREATE NEW BOARD'}
            />
        </div>
    );
};

export default DesignBoardDrawerCopyPinsMain;
